export default __webpack_public_path__ + "static/media/5.4914d9af.png";